import petroffTheme, { logo as petroffLogo }  from './petroff.theme';
import skylineTheme, { logo as skylineLogo } from './skyline.theme';
import config from '../clientConfig';

const themeService = {};

themeService.getTitle = () => config.isPetroff ? 'Petroff Towing' : 'Skyline Diesel & Towing';

themeService.getTheme = () => {
    return config.isPetroff ? petroffTheme : skylineTheme;
} 

themeService.logo = config.isPetroff ? petroffLogo : skylineLogo;

export default themeService;
